module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/3/4-62d3ee0dc9cbd8b06c29a8bc6959a025.jpg";